import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SiteLayout from "../components/feature/SiteLayout";
import CategoryPage from "../pages/category/page";
import MovieDetailPage from "../pages/movie/page";
import NewsListPage from "../pages/news/page";
import NewsDetailPage from "../pages/news/detail/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/:type",
        element: <CategoryPage />,
      },
      {
        path: "news/:category",
        element: <NewsListPage />,
      },
      {
        path: "news/detail/:id",
        element: <NewsDetailPage />,
      },
      {
        path: "movie/:id",
        element: <MovieDetailPage />,
      },
      {
        path: "search",
        element: <SearchPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;